// extracted by mini-css-extract-plugin
module.exports = {"start":"styles-module--start--2bORU","pagePadding":"styles-module--pagePadding--yYdw1","list":"styles-module--list--2Z9y-"};